// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the page-content has enough padding to avoid footer overlap */
.page-content.candidate-form {
  padding-bottom: 90px; /* Adjust based on footer height */
  min-height: calc(100vh - 100px); /* Ensure content takes full viewport height minus header/footer */
}

/* view form css */

.admin-dash .p-tabview-nav {
  gap: 3%;
  padding-left: 30px;
}

.admin-dash .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: 1px solid #eee;
  margin-bottom: 10px;
  border-radius: 4px;
}

.user-box {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
}

.admin-dash {
  margin-top: 6%;
  margin-bottom: 5%;
}

.admin-dash .p-column-title {
  font-weight: 600;
}

.admin-dash .p-datatable .p-datatable-thead>tr>th {
  padding: 10px 8px;
}

.admin-dash .p-dropdown:not(.p-disabled):hover {
  background-image: var(--backclr) !important;
}


.breadcrumb ol {
  padding-left: 0px;
}

.breadcrumb .p-breadcrumb {
  border: none;
  padding: 10px 0px;
}

.storage img {
  width: 120px;
}

.head-user {
  font-size: 17px;
  font-weight: 600;
}

.usermanagement-tab .p-tabview-nav {
  gap: 0px !important;
  padding-left: 0px;
  background-color: #f3f4f6 !important;
  width: fit-content;
  border-radius: 5px;
  border: 1px solid #e3e3e36b;
}

.usermanagement-tab .p-tabview-nav .p-unselectable-text.p-tabview-selected.p-highlight a {
  margin: 0px;
}

.usermanagement-tab .p-tabview-nav .p-tabview-nav-link {
  margin: 0px;
}

.usermanagement-tab .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  margin: 0px !important;
}

.usermanagement-tab .p-tabview-nav-link {
  margin: 0px !important;
}

.usermanagement-main .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none;
}

.heading-sz {
  font-size: 16px;
  font-weight: 600;
}

.heading-szm {
  font-size: 15px;
  font-weight: 600;
}

.usermanagement-main .p-tabview-panels {
  padding: 0px;
  margin-top: 25px;
margin-bottom: 80px;
}

.usermanagement-main .p-button {
  border-radius: 4px !important;
}


body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  position: relative;
}

body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {
  content: attr(data-full-text);
  white-space: normal;
}

body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li.mm-active a {
  font-weight: 600;
}

.lookup-cust a {
  background-color: #eaf1fb;
  color: #000;
}

.lookup-cust .p-accordion .p-accordion-header .p-accordion-header-link {
  padding: 15px !important;
  border-radius: 4px !important;
}


.lookup-cust .p-button.p-button-info {
  background-color: transparent;
}

.lookup-cust .p-button.p-button-danger {
  background-color: transparent;

}

.lookup-cust button {
  border-radius: 4px;
}

.job-posting-container {
  display: flex;
  justify-content: center;
  padding: 16px;
  background-color: var(--white);
  /* min-height: 100vh; */
  color: white;
}

.job-posting-card {
  width: 100%;
  max-width: 800px;
  background-color: var(--white);
  color: var(--black);
  /* border: 1px solid #2d3748; */
  border-radius: 8px;
  padding: 24px;
}

.job-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.job-logo {
  width: 64px;
  height: 64px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  color: #1a202c;
  font-weight: bold;
  font-size: 14px;
}

.job-header-content {
  flex: 1 1;
}

.company-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.job-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}

.job-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.job-badge {
  padding: 4px 8px;
  background-color: var(--gsbgcolor);
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.divider {
  height: 1px;
  background-color: #2d3748;
  margin: 24px 0;
}

.job-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.section-content {
  color: var(--black);
}

.job-list {
  padding-left: 24px;
  color: var(--black);
  list-style-type: disc;
  line-height: 1.5;
}

.job-list-ordered {
  padding-left: 24px;
  color: var(--black);
  list-style-type: decimal;
  line-height: 1.5;
}



/* start */


.application-form-container {
  padding: 1rem;
  max-width: 800px;
  margin: auto;
  color: #fff;
  background: var(--white);
}

.application-card {
  /* padding: 1.5rem; */
  border-radius: 8px;
  background: #1e1e1e;
}

.form-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #000;
}

.form-subtitle,
.quick-apply-title,
.option-description {
  color: #000;
  margin-bottom: 1rem;
  border-radius: 5px;
}

.quick-apply-flex {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.option-wrapper {
  flex: 1 1;
}

.option-card {
  text-align: center;
  padding: 10px;
  border-radius: 6px;
  background: var(--white);
  border: 1px solid #eee;
}

.apply-small-form .p-button {
  margin: 0.5rem 0;
  /* width: 100%; */
  border-radius: 5px;

}

.apply-small-form .p-card .p-card-content {
  padding: 10px 0px;
}

.candidate-form .card {
  margin-bottom: 5px;
}

.job-id {
  font-weight: 500;
}

.thankyou-img {
  width: 250px;
  border-radius: 50%;
  margin: 0 auto;
  display: block;
}

.reminder-popup .p-card .p-card-content {
  padding: 0px !important;
}

.reminder-popup .p-card .p-card-body {
  padding: 10px 20px !important;

}

.reminder-btn {
  width: 50%;
  border-radius: 4px;
}

.reminder-btnfull {
  width: 100%;
  border-radius: 4px;
  margin-top: 10px;
}

.reminder-popup .p-card-body {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  background-color: #f9fafb;
}

.reminder-popup .p-card {
  box-shadow: none;
}

.profile-back {
  background-color: #eee;
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 50%;
}

.profile-name {
  font-size: 15px;
  font-weight: 800;
}

.role-name {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 4px;
}

.interview-details {
  background-color: #f9fafb;
  border: 1px solid #eee;
}

.reminder-popup .p-menu {
  width: 120px;
}

.p-tag {
  background: #6365f12e;
  color: #000;
  font-size: 0.75rem;
  font-weight: 400;
  padding: 0.25rem 0.8rem;
  border-radius: 16px;
}

.p-tag.p-tag-success {
  background-color: #22c55e5c;
  color: #4b5563;
}

.p-tag.p-tag-info {
  background-color: #0ea5e947;
  color: #000;
}

.interview-details .p-button {
  background-color: transparent;
  border: none;
}

.interview-details .p-button:not(:disabled):hover {
  background-color: transparent;
  border: none;
}

.active-card1 {
  border: 2px solid #0e527d !important;
  box-shadow: 0 0 10px rgba(0, 122, 217, 0.5);
}

.datatable-check input[type="checkbox"] {
  margin: auto;
  display: block;
}

.action-icons i {
  font-size: 16px;
  /* color: var(--black); */
}

.action-icons .mainbtn:hover i {
  color: var(--white);
}


@media screen and (max-width: 768px) {
  .quick-apply-flex {
    flex-direction: column;
  }

  .option-wrapper {
    width: 100%;
  }
}

.pipe-table .p-badge.p-badge-success {

  padding: 1px 2px;
  font-size: 12px;
}

.view-form-sidebar.table-sec .p-tabview .p-tabview-nav {
  justify-content: space-between;
  padding-left: 10px !important;
  margin-bottom: 10px !important;
}

.view-form-sidebar.table-sec .p-dropdown {
  background: var(--backclr);
  border: none;
}

.view-form-sidebar .p-dropdown:not(.p-disabled):hover {
  background: var(--backclr);
  border: 1px solid var(--border-color);
}

.dispaly-mob {
  display: none !important;
}

.disply-desk {
  display: none !important;
}

.footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {
  border-left: 2px solid #e3e3e3;
  height: 25px;
  padding-left: 15px;
}

.footer-tabsec {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 0px;
}

.footer-proerty {
  display: flex;
  align-items: center;
}


.close-tabssection ul {
  display: flex;
  flex-wrap: wrap;
}


@media screen and (max-width: 1200px) {
  .dispaly-mob {
    display: block !important;
  }

  .footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {
    border-left: none;
    height: 25px;
    padding-left: 0px;
  }

}

@media (min-width: 441px) and (max-width: 1450px) {
  .admin-dash {
    margin-top: 14%;
    margin-bottom: 5%;
  }

}

@media screen and (max-width: 440px) {
  .admin-dash {
    margin-top: 24%;
    margin-bottom: 5%;
  }


}


@media screen and (max-width: 575px) {

  .footer-property {
    justify-content: center;

  }

  .footer-back .gear-picklist {
    border-right: none;
    padding-right: none;
    padding: 8px 0px 0px 0px;
  }
}



@media screen and (max-width: 1199px) {
  .admin-dash {
    margin-bottom: 13%;
  }

  .admin-dash .p-tabview-nav {
    gap: 2%;
  }

  .adminsetting-page {
    margin-bottom: 80px;
  }

}


@media screen and (min-width: 1201px) {

  .disply-desk {
    display: flex !important;
    justify-content: end !important;
  }

}

datatable-size .p-datatable .p-datatable-tbody>tr>td {
  padding: 2px 12px 2px 12px !important;
}

/* my accounrt start */

.profile-preview-container {
  /* max-width: 1000px; */
  margin: auto;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* border-radius: 8px; */
  overflow: hidden;
}

.profile-header {
  background-color: #f7fafc;
  padding: 20px;
}

.profile-header-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.profile-image-container {
  position: relative;
}

.profile-image {
  width: 128px;
  height: 128px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.change-photo-btn {
  position: absolute;
  bottom: 10px;
  right: 0;
  color: white;
  padding: 6px 10px;
  border-radius: 50%;
  background-image: var(--blue-gradient-angle);
  cursor: pointer;
  border: none;
}

.profile-name {
  font-size: 16px;
  font-weight: bold;
  color: #2d3748;
}

.profile-role {
  color: #4a5568;
}

.tabs {
  border-bottom: 2px solid #e2e8f0;
  display: flex;
}

.tab-btn {
  padding: 12px 24px;
  font-weight: 500;
  color: #4a5568;
  cursor: pointer;
  background: none;
  border: none;
}

.tab-btn.active-tab {
  color: #3182ce;
  border-bottom: 2px solid #3182ce;
}

.tab-btn.disabled {
  color: #a0aec0;
  cursor: not-allowed;
}

.profile-content {
  padding: 20px;
margin-bottom: 68px;
}

.profile-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.left-column,
.right-column {
  display: flex;
  flex-direction: column;
}

.profile-input {
  width: 100%;
  padding: 10px;
  background: none;
  border: 1px solid #ececf1;
  border-radius: 4px;
}

.password-container {
  display: flex;
  gap: 10px;
}

.change-btn {
  padding: 8px 16px;
  background-image: var(--blue-gradient-angle);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

.change-btn:hover {
  background-color: #2b6cb0;
}

.update-btn,
.upload-btn {
  width: fit-content;
  padding: 6px 16px;
  background-image: var(--blue-gradient-angle);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

.update-btn:hover,
.upload-btn:hover {
  background-color: #2b6cb0;
}

.password-dialog,
.photo-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.5); */
  display: flex;
  justify-content: center;
  align-items: center;
}


.dialog-content {
  background-color: white;
  padding: 30px 30px;
  border-radius: 4px;
  width: 28vw;
  box-shadow: -1px -1px 12px 7px #f1f1f1e6;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-btn {
  font-size: 14px;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.drop-zone {
  border: 2px dashed #cbd5e0;
  padding: 40px;
  text-align: center;
  border-radius: 8px;
  display: flex;
  justify-content: end;
}

.choose-file-btn {
  padding: 10px 20px;
  background-color: #3182ce;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.choose-file-btn:hover {
  background-color: #2b6cb0;
}


.Change-password {
  display: flex !important;
  justify-content: space-between !important;
  margin-bottom: 13px !important;
}

.preview-image-container {
  text-align: center;
  margin-bottom: 10px;
}

.preview-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.upload-resumes .custom-choose-btn .p-button-rounded .p-button-outlined .p-button .p-fileupload-choose .p-component .p-button-icon-only {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  border: 1px solid var(--backclr);
  color: var(--white);
  padding: 7px 18px;
}

.upload-resumes .p-button {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  border: 1px solid var(--backclr);
  color: var(--white);
  padding: 7px 18px;
  border-radius: 100%;
}

.import-head{
    font-size: 16px;
    font-weight: 500;
}
.import-head {
  font-size: 16px;
  font-weight: 500;

}

.import-fw {
  font-weight: 500;
}

.main-button {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
  border: none !important;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 15px;
}

.upload-resumes .p-fileupload-content i{
  display: none;
}


.upload-resumes .p-fileupload-content span{
  margin: 0 !important;
  padding: 0px !important;
  font-size: 15px !important;
  justify-content: start;
}

.clr-icons {
  display: flex;
  justify-content: end;
}

.actionitem-import .csvbtn.p-button {
  color: var(--white);
  background: #06b6d4;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 36px;
  height: 36px;
}
.actionitem-import .xlsbtn.p-button {
  color: var(--white);
  background: #22c55e;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 36px;
  height: 36px;
}
.actionitem-import .pdfbtn.p-button {
  color: var(--white);
  background: #f97316;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 36px;
  height: 36px;
}

.usermanagement-tab .p-datatable .p-datatable-tbody > tr > td{
  padding: 0.1rem 1rem;
}

.profile-dropdown .p-cascadeselect-item-active>.p-cascadeselect-sublist-wrapper {
  display: block;
  left: -123% !important;
  top: 46px !important;
}


/* tab section css start */

.dynamic-tab .p-button {
  background-color: transparent;
  border: none;
  color: var(--black);
  padding: 2px 0px;
  margin: 0;
}

.dynamic-tab .p-button.p-button-icon-only {
  width: 20px;
  background: transparent;
}

.footer-tabsec .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 3px 10px !important;
  border: 1px solid #e0e0ea3d;
  border-radius: 5px;
}
 .p-menu-list{
  padding-left: 0 !important;
}

/* tab section css end */

/* Pipeline Accordian start */


.pipeline-acc .p-datatable .p-datatable-tbody > tr > td{
  padding: 0rem 1rem;
}

/* Pipeline Accordian end */


/* auto complete start */

.p-autocomplete-items{
  padding-left: 0px;
}


.footer-tabsec, .dynamic-tab {
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}

.tabsmargin{
  margin-top: 100px;
margin-bottom: 100px;
}




.expanded-row {
  background-color: #f0f8ff !important; /* Light blue background for expanded rows */
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/style-new.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,oBAAoB,EAAE,kCAAkC;EACxD,+BAA+B,EAAE,kEAAkE;AACrG;;AAEA,kBAAkB;;AAElB;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB,mBAAmB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;;;AAIA,UAAU;;;AAGV;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,eAAe;AACjB;;;AAGA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;;AAGF;;;AAGA;;EAEE;IACE,uBAAuB;;EAEzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;;;;AAIA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,mBAAmB;EACrB;;AAEF;;;AAGA;;EAEE;IACE,wBAAwB;IACxB,+BAA+B;EACjC;;AAEF;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;;AAEtB;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf,mBAAmB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;EAC1D,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;EAC1D,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;;;AAGA,0BAA0B;;AAE1B;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;CACC;EACC,0BAA0B;AAC5B;;AAEA,wBAAwB;;AAExB,6BAA6B;;;AAG7B;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;;;AAG3B,wBAAwB;;AAExB;EACE,iBAAiB;AACnB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB,oBAAoB;AACpB;;;;;AAKA;EACE,oCAAoC,EAAE,4CAA4C;AACpF","sourcesContent":["/* Ensure the page-content has enough padding to avoid footer overlap */\n.page-content.candidate-form {\n  padding-bottom: 90px; /* Adjust based on footer height */\n  min-height: calc(100vh - 100px); /* Ensure content takes full viewport height minus header/footer */\n}\n\n/* view form css */\n\n.admin-dash .p-tabview-nav {\n  gap: 3%;\n  padding-left: 30px;\n}\n\n.admin-dash .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: 1px solid #eee;\n  margin-bottom: 10px;\n  border-radius: 4px;\n}\n\n.user-box {\n  border: 1px solid #ccc;\n  padding: 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.admin-dash {\n  margin-top: 6%;\n  margin-bottom: 5%;\n}\n\n.admin-dash .p-column-title {\n  font-weight: 600;\n}\n\n.admin-dash .p-datatable .p-datatable-thead>tr>th {\n  padding: 10px 8px;\n}\n\n.admin-dash .p-dropdown:not(.p-disabled):hover {\n  background-image: var(--backclr) !important;\n}\n\n\n.breadcrumb ol {\n  padding-left: 0px;\n}\n\n.breadcrumb .p-breadcrumb {\n  border: none;\n  padding: 10px 0px;\n}\n\n.storage img {\n  width: 120px;\n}\n\n.head-user {\n  font-size: 17px;\n  font-weight: 600;\n}\n\n.usermanagement-tab .p-tabview-nav {\n  gap: 0px !important;\n  padding-left: 0px;\n  background-color: #f3f4f6 !important;\n  width: fit-content;\n  border-radius: 5px;\n  border: 1px solid #e3e3e36b;\n}\n\n.usermanagement-tab .p-tabview-nav .p-unselectable-text.p-tabview-selected.p-highlight a {\n  margin: 0px;\n}\n\n.usermanagement-tab .p-tabview-nav .p-tabview-nav-link {\n  margin: 0px;\n}\n\n.usermanagement-tab .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  margin: 0px !important;\n}\n\n.usermanagement-tab .p-tabview-nav-link {\n  margin: 0px !important;\n}\n\n.usermanagement-main .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: none;\n}\n\n.heading-sz {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.heading-szm {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.usermanagement-main .p-tabview-panels {\n  padding: 0px;\n  margin-top: 25px;\nmargin-bottom: 80px;\n}\n\n.usermanagement-main .p-button {\n  border-radius: 4px !important;\n}\n\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  position: relative;\n}\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {\n  content: attr(data-full-text);\n  white-space: normal;\n}\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li.mm-active a {\n  font-weight: 600;\n}\n\n.lookup-cust a {\n  background-color: #eaf1fb;\n  color: #000;\n}\n\n.lookup-cust .p-accordion .p-accordion-header .p-accordion-header-link {\n  padding: 15px !important;\n  border-radius: 4px !important;\n}\n\n\n.lookup-cust .p-button.p-button-info {\n  background-color: transparent;\n}\n\n.lookup-cust .p-button.p-button-danger {\n  background-color: transparent;\n\n}\n\n.lookup-cust button {\n  border-radius: 4px;\n}\n\n.job-posting-container {\n  display: flex;\n  justify-content: center;\n  padding: 16px;\n  background-color: var(--white);\n  /* min-height: 100vh; */\n  color: white;\n}\n\n.job-posting-card {\n  width: 100%;\n  max-width: 800px;\n  background-color: var(--white);\n  color: var(--black);\n  /* border: 1px solid #2d3748; */\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.job-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.job-logo {\n  width: 64px;\n  height: 64px;\n  background-color: white;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  color: #1a202c;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.job-header-content {\n  flex: 1;\n}\n\n.company-name {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.job-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 16px;\n}\n\n.job-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.job-badge {\n  padding: 4px 8px;\n  background-color: var(--gsbgcolor);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.divider {\n  height: 1px;\n  background-color: #2d3748;\n  margin: 24px 0;\n}\n\n.job-section {\n  margin-bottom: 24px;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n\n.section-content {\n  color: var(--black);\n}\n\n.job-list {\n  padding-left: 24px;\n  color: var(--black);\n  list-style-type: disc;\n  line-height: 1.5;\n}\n\n.job-list-ordered {\n  padding-left: 24px;\n  color: var(--black);\n  list-style-type: decimal;\n  line-height: 1.5;\n}\n\n\n\n/* start */\n\n\n.application-form-container {\n  padding: 1rem;\n  max-width: 800px;\n  margin: auto;\n  color: #fff;\n  background: var(--white);\n}\n\n.application-card {\n  /* padding: 1.5rem; */\n  border-radius: 8px;\n  background: #1e1e1e;\n}\n\n.form-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  color: #000;\n}\n\n.form-subtitle,\n.quick-apply-title,\n.option-description {\n  color: #000;\n  margin-bottom: 1rem;\n  border-radius: 5px;\n}\n\n.quick-apply-flex {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.option-wrapper {\n  flex: 1;\n}\n\n.option-card {\n  text-align: center;\n  padding: 10px;\n  border-radius: 6px;\n  background: var(--white);\n  border: 1px solid #eee;\n}\n\n.apply-small-form .p-button {\n  margin: 0.5rem 0;\n  /* width: 100%; */\n  border-radius: 5px;\n\n}\n\n.apply-small-form .p-card .p-card-content {\n  padding: 10px 0px;\n}\n\n.candidate-form .card {\n  margin-bottom: 5px;\n}\n\n.job-id {\n  font-weight: 500;\n}\n\n.thankyou-img {\n  width: 250px;\n  border-radius: 50%;\n  margin: 0 auto;\n  display: block;\n}\n\n.reminder-popup .p-card .p-card-content {\n  padding: 0px !important;\n}\n\n.reminder-popup .p-card .p-card-body {\n  padding: 10px 20px !important;\n\n}\n\n.reminder-btn {\n  width: 50%;\n  border-radius: 4px;\n}\n\n.reminder-btnfull {\n  width: 100%;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.reminder-popup .p-card-body {\n  border: 1px solid #eeeeee;\n  border-radius: 4px;\n  background-color: #f9fafb;\n}\n\n.reminder-popup .p-card {\n  box-shadow: none;\n}\n\n.profile-back {\n  background-color: #eee;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  border-radius: 50%;\n}\n\n.profile-name {\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.role-name {\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 4px;\n}\n\n.interview-details {\n  background-color: #f9fafb;\n  border: 1px solid #eee;\n}\n\n.reminder-popup .p-menu {\n  width: 120px;\n}\n\n.p-tag {\n  background: #6365f12e;\n  color: #000;\n  font-size: 0.75rem;\n  font-weight: 400;\n  padding: 0.25rem 0.8rem;\n  border-radius: 16px;\n}\n\n.p-tag.p-tag-success {\n  background-color: #22c55e5c;\n  color: #4b5563;\n}\n\n.p-tag.p-tag-info {\n  background-color: #0ea5e947;\n  color: #000;\n}\n\n.interview-details .p-button {\n  background-color: transparent;\n  border: none;\n}\n\n.interview-details .p-button:not(:disabled):hover {\n  background-color: transparent;\n  border: none;\n}\n\n.active-card1 {\n  border: 2px solid #0e527d !important;\n  box-shadow: 0 0 10px rgba(0, 122, 217, 0.5);\n}\n\n.datatable-check input[type=\"checkbox\"] {\n  margin: auto;\n  display: block;\n}\n\n.action-icons i {\n  font-size: 16px;\n  /* color: var(--black); */\n}\n\n.action-icons .mainbtn:hover i {\n  color: var(--white);\n}\n\n\n@media screen and (max-width: 768px) {\n  .quick-apply-flex {\n    flex-direction: column;\n  }\n\n  .option-wrapper {\n    width: 100%;\n  }\n}\n\n.pipe-table .p-badge.p-badge-success {\n\n  padding: 1px 2px;\n  font-size: 12px;\n}\n\n.view-form-sidebar.table-sec .p-tabview .p-tabview-nav {\n  justify-content: space-between;\n  padding-left: 10px !important;\n  margin-bottom: 10px !important;\n}\n\n.view-form-sidebar.table-sec .p-dropdown {\n  background: var(--backclr);\n  border: none;\n}\n\n.view-form-sidebar .p-dropdown:not(.p-disabled):hover {\n  background: var(--backclr);\n  border: 1px solid var(--border-color);\n}\n\n.dispaly-mob {\n  display: none !important;\n}\n\n.disply-desk {\n  display: none !important;\n}\n\n.footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {\n  border-left: 2px solid #e3e3e3;\n  height: 25px;\n  padding-left: 15px;\n}\n\n.footer-tabsec {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-bottom: 0px;\n}\n\n.footer-proerty {\n  display: flex;\n  align-items: center;\n}\n\n\n.close-tabssection ul {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n\n@media screen and (max-width: 1200px) {\n  .dispaly-mob {\n    display: block !important;\n  }\n\n  .footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {\n    border-left: none;\n    height: 25px;\n    padding-left: 0px;\n  }\n\n}\n\n@media (min-width: 441px) and (max-width: 1450px) {\n  .admin-dash {\n    margin-top: 14%;\n    margin-bottom: 5%;\n  }\n\n}\n\n@media screen and (max-width: 440px) {\n  .admin-dash {\n    margin-top: 24%;\n    margin-bottom: 5%;\n  }\n\n\n}\n\n\n@media screen and (max-width: 575px) {\n\n  .footer-property {\n    justify-content: center;\n\n  }\n\n  .footer-back .gear-picklist {\n    border-right: none;\n    padding-right: none;\n    padding: 8px 0px 0px 0px;\n  }\n}\n\n\n\n@media screen and (max-width: 1199px) {\n  .admin-dash {\n    margin-bottom: 13%;\n  }\n\n  .admin-dash .p-tabview-nav {\n    gap: 2%;\n  }\n\n  .adminsetting-page {\n    margin-bottom: 80px;\n  }\n\n}\n\n\n@media screen and (min-width: 1201px) {\n\n  .disply-desk {\n    display: flex !important;\n    justify-content: end !important;\n  }\n\n}\n\ndatatable-size .p-datatable .p-datatable-tbody>tr>td {\n  padding: 2px 12px 2px 12px !important;\n}\n\n/* my accounrt start */\n\n.profile-preview-container {\n  /* max-width: 1000px; */\n  margin: auto;\n  background-color: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  /* border-radius: 8px; */\n  overflow: hidden;\n}\n\n.profile-header {\n  background-color: #f7fafc;\n  padding: 20px;\n}\n\n.profile-header-content {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.profile-image-container {\n  position: relative;\n}\n\n.profile-image {\n  width: 128px;\n  height: 128px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 4px solid white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.change-photo-btn {\n  position: absolute;\n  bottom: 10px;\n  right: 0;\n  color: white;\n  padding: 6px 10px;\n  border-radius: 50%;\n  background-image: var(--blue-gradient-angle);\n  cursor: pointer;\n  border: none;\n}\n\n.profile-name {\n  font-size: 16px;\n  font-weight: bold;\n  color: #2d3748;\n}\n\n.profile-role {\n  color: #4a5568;\n}\n\n.tabs {\n  border-bottom: 2px solid #e2e8f0;\n  display: flex;\n}\n\n.tab-btn {\n  padding: 12px 24px;\n  font-weight: 500;\n  color: #4a5568;\n  cursor: pointer;\n  background: none;\n  border: none;\n}\n\n.tab-btn.active-tab {\n  color: #3182ce;\n  border-bottom: 2px solid #3182ce;\n}\n\n.tab-btn.disabled {\n  color: #a0aec0;\n  cursor: not-allowed;\n}\n\n.profile-content {\n  padding: 20px;\nmargin-bottom: 68px;\n}\n\n.profile-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.left-column,\n.right-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.profile-input {\n  width: 100%;\n  padding: 10px;\n  background: none;\n  border: 1px solid #ececf1;\n  border-radius: 4px;\n}\n\n.password-container {\n  display: flex;\n  gap: 10px;\n}\n\n.change-btn {\n  padding: 8px 16px;\n  background-image: var(--blue-gradient-angle);\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  border: none;\n}\n\n.change-btn:hover {\n  background-color: #2b6cb0;\n}\n\n.update-btn,\n.upload-btn {\n  width: fit-content;\n  padding: 6px 16px;\n  background-image: var(--blue-gradient-angle);\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  border: none;\n}\n\n.update-btn:hover,\n.upload-btn:hover {\n  background-color: #2b6cb0;\n}\n\n.password-dialog,\n.photo-dialog {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* background-color: rgba(0, 0, 0, 0.5); */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n.dialog-content {\n  background-color: white;\n  padding: 30px 30px;\n  border-radius: 4px;\n  width: 28vw;\n  box-shadow: -1px -1px 12px 7px #f1f1f1e6;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.close-btn {\n  font-size: 14px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.drop-zone {\n  border: 2px dashed #cbd5e0;\n  padding: 40px;\n  text-align: center;\n  border-radius: 8px;\n  display: flex;\n  justify-content: end;\n}\n\n.choose-file-btn {\n  padding: 10px 20px;\n  background-color: #3182ce;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.choose-file-btn:hover {\n  background-color: #2b6cb0;\n}\n\n\n.Change-password {\n  display: flex !important;\n  justify-content: space-between !important;\n  margin-bottom: 13px !important;\n}\n\n.preview-image-container {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.preview-image {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.upload-resumes .custom-choose-btn .p-button-rounded .p-button-outlined .p-button .p-fileupload-choose .p-component .p-button-icon-only {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  border: 1px solid var(--backclr);\n  color: var(--white);\n  padding: 7px 18px;\n}\n\n.upload-resumes .p-button {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  border: 1px solid var(--backclr);\n  color: var(--white);\n  padding: 7px 18px;\n  border-radius: 100%;\n}\n\n.import-head{\n    font-size: 16px;\n    font-weight: 500;\n}\n.import-head {\n  font-size: 16px;\n  font-weight: 500;\n\n}\n\n.import-fw {\n  font-weight: 500;\n}\n\n.main-button {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n  border: none !important;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n}\n\n.upload-resumes .p-fileupload-content i{\n  display: none;\n}\n\n\n.upload-resumes .p-fileupload-content span{\n  margin: 0 !important;\n  padding: 0px !important;\n  font-size: 15px !important;\n  justify-content: start;\n}\n\n.clr-icons {\n  display: flex;\n  justify-content: end;\n}\n\n.actionitem-import .csvbtn.p-button {\n  color: var(--white);\n  background: #06b6d4;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 36px;\n  height: 36px;\n}\n.actionitem-import .xlsbtn.p-button {\n  color: var(--white);\n  background: #22c55e;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 36px;\n  height: 36px;\n}\n.actionitem-import .pdfbtn.p-button {\n  color: var(--white);\n  background: #f97316;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 36px;\n  height: 36px;\n}\n\n.usermanagement-tab .p-datatable .p-datatable-tbody > tr > td{\n  padding: 0.1rem 1rem;\n}\n\n.profile-dropdown .p-cascadeselect-item-active>.p-cascadeselect-sublist-wrapper {\n  display: block;\n  left: -123% !important;\n  top: 46px !important;\n}\n\n\n/* tab section css start */\n\n.dynamic-tab .p-button {\n  background-color: transparent;\n  border: none;\n  color: var(--black);\n  padding: 2px 0px;\n  margin: 0;\n}\n\n.dynamic-tab .p-button.p-button-icon-only {\n  width: 20px;\n  background: transparent;\n}\n\n.footer-tabsec .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  padding: 3px 10px !important;\n  border: 1px solid #e0e0ea3d;\n  border-radius: 5px;\n}\n .p-menu-list{\n  padding-left: 0 !important;\n}\n\n/* tab section css end */\n\n/* Pipeline Accordian start */\n\n\n.pipeline-acc .p-datatable .p-datatable-tbody > tr > td{\n  padding: 0rem 1rem;\n}\n\n/* Pipeline Accordian end */\n\n\n/* auto complete start */\n\n.p-autocomplete-items{\n  padding-left: 0px;\n}\n\n\n.footer-tabsec, .dynamic-tab {\n  width: 100%;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.tabsmargin{\n  margin-top: 100px;\nmargin-bottom: 100px;\n}\n\n\n\n\n.expanded-row {\n  background-color: #f0f8ff !important; /* Light blue background for expanded rows */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
